import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        green:
          "border-[rgba(var(--color-badge-cyan-rgb),0.3)] bg-[rgba(var(--color-badge-cyan-rgb),0.15)] text-foreground px-5 py-1.5 text-sm font-normal backdrop-blur-[17px]",
        cyan:
          "border-[rgba(var(--color-badge-cyan-light-rgb),0.5)] bg-[rgba(var(--color-badge-cyan-light-rgb),0.3)] text-foreground px-5 py-1.5 text-sm font-normal backdrop-blur-[17px]",
        purple:
          "border-[rgba(var(--color-primary-500-rgb),0.3)] bg-[rgba(var(--color-primary-500-rgb),0.15)] text-primary px-5 py-1.5 text-sm font-normal backdrop-blur-[17px]",
        yellow:
          "border-[rgba(var(--color-badge-yellow-rgb),0.5)] bg-[rgba(var(--color-badge-yellow-rgb),0.3)] text-foreground px-5 py-1.5 text-sm font-normal backdrop-blur-[17px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
